import React from 'react';

const ALL_OPTIONS = ['A', 'B', 'C', 'D', 'E'];

// O robust_omr le sempre os 5 slots fisicos fixos (layout.py N_OPTS=5) e
// traduz a bolha marcada pra letra via indice (0=A..4=E) -- por isso a bolha
// de Certo/Errado PRECISA ficar nas posicoes de C e E (indices 2 e 4), nunca
// nos 2 primeiros slots (A/B), senao o OCR le a marcacao como resposta A/B.
const RIGHT_WRONG_INDEXES = [2, 4];

export default function AnswerKey(props) {
  const { index, question } = props;

  const altCount = question?.alternatives?.length;
  const activeIndexes = altCount < 4 ? RIGHT_WRONG_INDEXES : altCount === 4 ? [0, 1, 2, 3] : [0, 1, 2, 3, 4];

  return (
    <div className="answer-key">
      <div className="answer-key__number">{index + 1}</div>

      {/* 5 posicoes fisicas SEMPRE reservadas no layout (mesmo espaco ocupado),
          mas so' desenha o circulo/anel nas posicoes validas -- as outras viram
          um espacador invisivel. O robust_omr (estudologia-ocr, calibrate.py)
          foi reescrito pra calibrar/ler so' as posicoes que realmente tem anel
          impresso (any(opts) + agrupamento robusto a ocupacao desigual), entao
          nao precisa mais desenhar as 5 sempre so' pra calibracao funcionar. */}
      {ALL_OPTIONS.map((alternative, i) =>
        activeIndexes.includes(i) ? (
          <div
            className="answer-key__alternative"
            key={i}
          >
            {alternative}
          </div>
        ) : (
          <div
            className="answer-key__alternative answer-key__alternative--spacer"
            key={i}
          />
        )
      )}
      {/* <div className="answer-key__id">#{question?.id}</div> */}
    </div>
  );
}
